export default __webpack_public_path__ + "static/media/LightPinkBall.fb9ba6a9.svg";